import BaseApiService from './BaseApiService';

class ViewCompetitorsApiService extends BaseApiService {
    constructor() {
        super('competitors');
    }

    async get({ drugId, type, range, revenues, categories, breakApart, growthRates, growthRatesQuarters, startSyncView,  showCumulativeRevenueChart, getFicBicData = false }) {
        console.log('api called');

        const response = await this.request(
            { method: 'get', url: `/${drugId}`,
                params: {
                    type,
                    range,
                    revenues,
                    breakApart,
                    growthRates: growthRates.join(','),
                    growthRatesQuarters: growthRatesQuarters.join(','),
                    categories: categories.join(','),
                    startSyncView,
                    showCumulativeRevenueChart,
                    getFicBicData,
                }
            });

        return {
            revenues: response.revenues,
            cumulativeRevenueChart: (response.cumulativeRevenueChart !== undefined) ? response.cumulativeRevenueChart : null,
            chartFicBicData: (response.chartFicBicData !== undefined) ? response.chartFicBicData : null,
            events: response.events,
            classes: response.classes,
            subcategories: response.subcategories,
        };
    }
}

export default new ViewCompetitorsApiService();
